/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Technology
 */
export interface Technology {
    /**
     * 
     * @type {number}
     * @memberof Technology
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Technology
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Technology
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Technology
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Technology
     */
    logoPath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Technology
     */
    readonly assetsCount: number;
}

/**
 * Check if a given object implements the Technology interface.
 */
export function instanceOfTechnology(value: object): value is Technology {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('assetsCount' in value) || value['assetsCount'] === undefined) return false;
    return true;
}

export function TechnologyFromJSON(json: any): Technology {
    return TechnologyFromJSONTyped(json, false);
}

export function TechnologyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Technology {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'version': json['version'] == null ? undefined : json['version'],
        'description': json['description'] == null ? undefined : json['description'],
        'logoPath': json['logo_path'] == null ? undefined : json['logo_path'],
        'assetsCount': json['assets_count'],
    };
}

  export function TechnologyToJSON(json: any): Technology {
      return TechnologyToJSONTyped(json, false);
  }

  export function TechnologyToJSONTyped(value?: Omit<Technology, 'id'|'assets_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'version': value['version'],
        'description': value['description'],
        'logo_path': value['logoPath'],
    };
}

